import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, ordersReadyToPickActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersReadyToPickActions);

export default slice.reducer;
